export default "__VITE_ASSET__CTq25neJ__"